import { Component, Input, ViewChild } from '@angular/core';
import { SyslinkColumn } from 'projects/libraries/syslink-components/src/lib/helpers/SyslinkColumn';
import { Third } from '../../../third.model';
import { ViewComponent } from 'projects/libraries/syslink-components/src/lib/helpers/view/view.component';
import { StockMoveIncomingsService } from 'projects/erp-app/src/app/stocks/stock-move-incomings/stock-move-incomings/stock-move-incomings.service';
import { StockMoveIncomingGridComponent } from 'projects/erp-app/src/app/stocks/stock-move-incomings/stock-move-incoming-grid/stock-move-incoming-grid.component';

@Component({
  selector: 'app-third-document-relation-stock-stock-move-supplier-incomings',
  templateUrl: './third-document-relation-stock-stock-move-supplier-incomings.component.html',
  styleUrls: ['./third-document-relation-stock-stock-move-supplier-incomings.component.scss']
})
export class ThirdDocumentRelationStockStockMoveSupplierIncomingsComponent extends ViewComponent {
  @Input() public element: Third = new Third();

  public filter: string | string[] | undefined = undefined;

  constructor(
    private stockMoveIncomingsService: StockMoveIncomingsService,
  ) {
    super();
  }

  override ngOnInit(): void {
    if (this.element.Id) {
      this.filter = ["ThirdId.Id eq " + this.element.Id + " and Type eq 'supplier'"];
    }
  }

  @ViewChild('GridComponent') GridComponent: StockMoveIncomingGridComponent = new StockMoveIncomingGridComponent(this.stockMoveIncomingsService);
  public columns: SyslinkColumn[] = [
    new SyslinkColumn({ field: "No", label: "GRID.CAPTION.NO", width: 150, sortIndex: 2, sortDirection: 'desc' }),
    new SyslinkColumn({ field: "Subject", label: "Subject" }),
    new SyslinkColumn({ field: "CurrentStatusLink.StatusId.Name", label: "Status", cellTemplate: 'statusText-cell', data: { getStatusLabel: this.GridComponent.getStatusCellLabel, getStatusDate: this.GridComponent.getStatusCellDate, getStatusClass: this.GridComponent.getStatusCellClass, getStatusColor: this.GridComponent.getStatusCellColor }, width: 120 }),
    new SyslinkColumn({ field: "Deadline", label: 'StockMoveIncoming.Validity', type: "date" }),
    new SyslinkColumn({ field: "ExternalReference", label: "External reference", visible: true, width: 150 }),
    new SyslinkColumn({ field: "ResponsibleUserId.Fullname", label: "Responsible", width: 120 }),
    new SyslinkColumn({ field: "Date", label: "Date", type: "date", visible: false, width: 150 }),
    new SyslinkColumn({ field: "CurrentStatusLink.StatusId.Sequence", label: 'status incoming', sortIndex: 1, sortDirection: 'asc', width: 0, visible: false, filterable: false, headerFilterable: false, sortable: false })
  ];

  onAddButtonClicked() {
    window.open('/stockmoves/supplierincomings/new?ThirdId=' + this.element.Id);
  }


}